export default "__VITE_ASSET__ChxT3CWT__"